/**
 * PALETTE CATEGORIE — STANDARD per questo tool e per i PROSSIMI tool.
 *
 * Regola (decisione utente 2026-06-10): ogni TIPO di "pezzo" della conoscenza
 * ha la SUA tinta, identica ovunque appaia (mappe, chip, legende, viste
 * future). Tinte ≠ toni: i toni della stessa tinta si leggono come STATI
 * (evidenziato sì/no), le tinte diverse come CATEGORIE.
 *
 * L'accento brand (#8b4500, arancio bruciato) NON è una categoria: è riservato a
 * focus/selezione/autore-centrale. Quando nasce una nuova categoria di
 * pezzi, le si assegna QUI una tinta nuova (e nei token CSS).
 *
 * ⚠ Tenere in sync con le var CSS `--cat-*` in src/styles/tokens-brand.css
 * (i chip e gli stili DOM usano le var; gli SVG generati in TS usano questi hex).
 */
export const CATEGORY_COLORS = {
  /** Autore / nodo centrale — bordeaux brand */
  author: '#8b4500',
  /** Opera (work) — teal */
  work: '#1d5b6b',
  /** Tema generico (trattamenti: amore, natura, …) — prugna */
  theme: '#5d4a7e',
  /** Movimento (Romanticismo, Modernismo, …) — verde bosco */
  movement: '#2f6b4f',
  /** Genere / forma (Ode, Epica, Sonetto, …) — ardesia */
  genre: '#54678f',
  /** Periodo (Romantico, Vittoriano, …) — malva */
  period: '#8a5a7a',
} as const;

export type CategoryKind = keyof typeof CATEGORY_COLORS;
